import DeleteStage from './DeleteStage';

export default DeleteStage;
